export default __webpack_public_path__ + "static/media/service-1.0f765c48.jpg";